/**
 * Newsletter Form Enhancement
 * Adds double-submit protection and loading feedback to prevent rage clicks
 */

(function() {
  'use strict';

  // Handle all newsletter forms on the page
  function enhanceNewsletterForms() {
    const forms = document.querySelectorAll('form.newsletter-form');

    forms.forEach(form => {
      // Skip if already enhanced
      if (form.dataset.enhanced === 'true') return;
      form.dataset.enhanced = 'true';

      const submitButton = form.querySelector('button[type="submit"]');
      const emailInput = form.querySelector('input[type="email"]');

      if (!submitButton || !emailInput) return;

      // Add submit handler
      form.addEventListener('submit', function(e) {
        // Check if already submitting
        if (submitButton.disabled || submitButton.getAttribute('aria-disabled') === 'true') {
          e.preventDefault();
          return false;
        }

        // Validate email
        if (!emailInput.value || !emailInput.validity.valid) {
          return; // Let browser validation handle it
        }

        // Disable button and show loading state
        submitButton.disabled = true;
        submitButton.setAttribute('aria-disabled', 'true');
        submitButton.classList.add('loading');

        // Add a timeout to re-enable if something goes wrong (15 seconds)
        setTimeout(() => {
          if (submitButton.disabled) {
            submitButton.disabled = false;
            submitButton.removeAttribute('aria-disabled');
            submitButton.classList.remove('loading');
          }
        }, 15000);
      });

      // Re-enable on error
      form.addEventListener('invalid', function() {
        submitButton.disabled = false;
        submitButton.removeAttribute('aria-disabled');
        submitButton.classList.remove('loading');
      }, true);
    });
  }

  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceNewsletterForms);
  } else {
    enhanceNewsletterForms();
  }

  // Also run when sections are dynamically updated
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', enhanceNewsletterForms);
  }
})();
